<template>
  <div class="loginRole h100">
    <!-- <h1>This is an loginRole page</h1> -->
    <div class="box">
      <div :class="roles.indexOf('Admin')>-1?'selected':''" @click="roles.indexOf('Admin')>-1?jumpHome():message()">Admin</div>
      <div :class="roles.indexOf('HR')>-1?'selected':''" @click="roles.indexOf('HR')>-1?jumpHome():message()">HR</div>
      <div :class="roles.indexOf('SIP')>-1?'selected':''" @click="roles.indexOf('SIP')>-1?jumpHome():message()">SIP</div>
      <div :class="roles.indexOf('SFE')>-1?'selected':''" @click="roles.indexOf('SFE')>-1?jumpHome():message()">SFE</div>
      <div :class="roles.indexOf('Category BU')>-1?'selected':''" @click="roles.indexOf('Category BU')>-1?jumpHome():message()">Category BU</div>
      <!-- <div :class="roles.indexOf('Admin')<=-1&&roles.indexOf('HR')<=-1&&roles.indexOf('SIP')<=-1&&roles.indexOf('SFE')<=-1?'selected':''" @click="roles.indexOf('Admin')<=-1&&roles.indexOf('HR')<=-1&&roles.indexOf('SIP')<=-1&&roles.indexOf('SFE')<=-1?jumpHome():message()">Categroy BU</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginRole',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      loading: false
    }
  },
  beforeCreate () {
    // 开启遮罩层
    this.$loading({
      lock: true,
      text: '加载中',
      // spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 1)'
    })
  },
  created () {
    // 判断是否有code--获取信息/跳转重定向
    if (!sessionStorage.getItem('token')) {
      if (this.GetQueryString('code')) {
        sessionStorage.clear()
        this.getUserInfo()
      } else {
        if (!sessionStorage.getItem('token')) {
          // location.href = 'https://federation-qa.gsk.com/as/authorization.oauth2?redirect_uri=https%3A%2F%2Fwsisdevtest.gsk.com&client_id=422524a06e164cf5a1253b10cdc3f178&response_type=code'
          if (process.env.VUE_APP_REDIRECT_URL === 'https://incentive.boosal.com/#/login') {
            location.href = process.env.VUE_APP_REDIRECT_URL
            // 关闭遮罩层
            this.closeFullScreen()
          } else {
            location.href = process.env.VUE_APP_REDIRECT_URL
          }
        }
      }
    } else {
      // 赋值信息
      this.getSessionRoles()
    }
  },
  mounted () {},
  methods: {
    // 获取userInfo和token
    getUserInfo () {
      this.$http.get(this.API.ssologin, { params: { code: this.GetQueryString('code') } }).then((res) => {
        let data = res.data
        sessionStorage.setItem('userInfo', JSON.stringify(data.data.userInfo))
        sessionStorage.setItem('token', data.data.token)
        // 赋值信息
        this.getSessionRoles()
      })
    },
    // 跳转home页
    jumpHome () {
      // 跳转到主页面
      this.$router.push('/home')
    },
    // 提示信息
    message () {
      this.$message.error('无权限！')
    },
    // 获取地址栏参数
    GetQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2]); return null
    },
    // 开启遮罩层
    openFullScreen () {
      this.$loading({
        lock: true,
        text: '加载中',
        // spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 1)'
      })
    },
    // 关闭遮罩层
    closeFullScreen () {
      this.$loading().close()
    },
    // 获取session用户信息
    getSessionRoles () {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.userInfo !== null) {
        let arr = this.userInfo.roles
        let roles = []
        if (arr != null && arr.length > 0) {
          arr.forEach(ele => {
            roles.push(ele.roleName)
          })
        } else {
          this.$message.error('无权限！')
          sessionStorage.clear()
        }
        this.roles = roles
        // 判断CategoryBU直接跳转
        if (roles.indexOf('Category BU') > -1) {
          this.jumpHome()
        }
      }
      // 关闭遮罩层
      this.closeFullScreen()
    }
  }
}
</script>

<style lang="less" scoped>
.loginRole {
  background: url("../../assets/logo_bg.png") no-repeat center center / 100% 100%;
  .box {
    display: flex;
    flex-direction: column;
    div {
      margin: 40px 0 0 60px;
      color: #fff;
      background-color:#F77B3B;
      border: 1px solid #FFCA16;
      height: 50px;
      width: 180px;
      line-height: 50px;
      text-align: center;
      border-radius: 5px;
      font-weight: bold;
      font-size: 20px;
      opacity: 0.8;
      cursor:pointer;
    }
    .selected {
      color: #B61E00;
      background-color:#FFCA16;
      border-color: #F77B3B;
    }
  }
}
</style>
